export const AHRFootNote = (): JSX.Element => (
    <p>
      NWAU deductions for Avoidable Hospital Readmissions (AHRs) were first implemented in 2021-22, as part of NWAU21. Therefore, the only NWAU version used in the AHR dashboard is NWAU21.
    </p>
  )